export default {
  apiHttps: 'https://cargenic.aquila.uberspace.de/api', // It's better to require a config file
  apiWs: 'ws://cargenic.aquila.uberspace.de:63207', // It's better to require a config file
}
